import {
  ChannelManager,
  ROOMCLOUD_CHANNEL_MANAGER,
} from 'app/typings/channelManagers';
import type { ChannelManagerValue } from 'app/typings/channelManagers';

const CHANNEL_MANAGER_ORDER: ChannelManagerValue[] = [
  ChannelManager.D_EDGE,
  ChannelManager.SITEMINDER,
  ChannelManager.RESERVIT,
  ChannelManager.MEWS,
  ChannelManager.TRAVELCLICK,
  ChannelManager.CUBILIS,
  ChannelManager.ROOMCLOUD,
  ROOMCLOUD_CHANNEL_MANAGER.MISTER_BOOKING,
  ROOMCLOUD_CHANNEL_MANAGER.THAIS,
];

export const getSortedChannelManagersByImportance = (
  managers: ChannelManagerValue[]
): ChannelManagerValue[] => {
  return managers.sort(
    (a, b) =>
      CHANNEL_MANAGER_ORDER.indexOf(a) - CHANNEL_MANAGER_ORDER.indexOf(b)
  );
};
